
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PLAYERINTERVENTION_ACTION,
    FETCH_PLAYERINTERVENTION,
    FETCH_PLAYERTECHSAMLAB,
    FETCH_PLAYERTECHCAPTO,
    FETCH_PLAYERTECHLAUNCH,
    FETCH_PLAYERTECHHACK,
    FETCH_PLAYERTECHFSIRON,
    FETCH_PLAYERTECHFSDRIVER,
    FETCH_PLAYERTECHWEDGE,
    FETCH_PLAYERTECHCOURSE,
    FETCH_PLAYERTECHSPEED,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Player Intervention Actions
 */

    export const fetchPlayerIntervention = (id, startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getnewplyintlogdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERINTERVENTION, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerSamLab = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudsamdetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHSAMLAB, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerCaptoLab = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudcaptodetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHCAPTO, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerlaunch = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudlaunchdetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHLAUNCH, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerhack = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudhackdetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHHACK, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerFsIron = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudfsirondetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHFSIRON, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }
    
    export const fetchPlayerFsDriver = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudfsdriverdetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHFSDRIVER, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerWedge = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudwedgedetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHWEDGE, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerCourse = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudcoursedetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHCOURSE, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPlayerSpeed = (id,startdate, enddate) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
        }
        return (dispatch) => { 
            dispatch({ type:PLAYERINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getpistudspeeddetail', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PLAYERTECHSPEED, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }
    